module.exports = __webpack_public_path__ + "static/perek-6553539f9f14a9e7c53b23a13c3dbcf8.jpg";